export enum AppFeatures {
  CARTOGRAPHY,
}
